import React from 'react';
import { useTranslation } from 'react-i18next';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  // TikTok icon custom component since Lucide doesn't have a built-in TikTok icon
  const TikTokIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 12a4 4 0 1 0 4 4V4c5 0 5 8 9 8" />
    </svg>
  );

  const socialLinks = [
    { href: "https://www.instagram.com/fitnessbro.ai", label: "Instagram", icon: Instagram },
    { href: "https://www.tiktok.com/@fitnessbro.ai", label: "TikTok", icon: TikTokIcon },
  ];

  return (
    <footer className="bg-background text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Top Section - Only Logo and UVP */}
        <div className="mb-12">
          {/* Logo and UVP */}
          <div className="mb-8 md:mb-0 md:max-w-lg">
            <div className="flex items-center mb-4">
              <img
                src="/images/fitnessbro_logo.webp"
                alt="Fitnessbro Logo"
                width="256"
                height="256"
                className="h-10 w-auto mr-3"
              />
              <span className="font-semibold text-2xl">
                Fitnessbro
              </span> 
            </div>
            <p className="text-gray-400 text-sm md:text-base">
              {t('footer.uvp', 'Smetti di Contare Calorie, Inizia a Contare i Risultati')}
            </p>
          </div>
        </div>
        
        {/* Border Separator */}
        <div className="border-t border-gray-700 mb-8"></div>
        
        {/* Bottom Section: Copyright and Social */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-xs text-gray-500 mb-4 md:mb-0 order-2 md:order-1">
            © {new Date().getFullYear()} Fitnessbro. {t('footer.rightsReserved', 'Tutti i diritti riservati.')}
          </p>
          <div className="flex space-x-6 mb-4 md:mb-0 order-1 md:order-2">
            {socialLinks.map((link, index) => (
              <a 
                key={index}
                href={link.href} 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label={link.label} 
                className="text-gray-400 hover:text-secondary transition-colors"
              >
                <link.icon size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
